export const resolveDividendStatus = (payDate: string | null, todayKeyInBrt: string) => {
  if (!payDate) return 'Anunciado';
  const payDayKey = payDate.slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(payDayKey)) return 'Anunciado';
  return payDayKey <= todayKeyInBrt ? 'Pago' : 'Anunciado';
};
